import React, { useState } from 'react';
import { useScore } from './context/ScoreContext';

const SearchBar = ({ items, possibleAnswers, onSelect, onClose }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const maxResultsToShow = 12;
  const { getOptionIds } = useScore();

  const normalizeText = (text) => text
    .normalize('NFD') // Normalize to decomposed form
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[-_]/g, ' ') // remove hyphens and underscores
    .toLowerCase(); // Make the comparison case-insensitive;

  const handleKeyPress = (event) => {
    if (event.key === 'Escape') {
      onClose();
    }
  };

  // Filter items based on search term
  const filteredData = searchTerm ? items
    .filter((item) =>
      normalizeText(item.name).includes(normalizeText(searchTerm))
      // item.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .slice(0, maxResultsToShow) : [];

  const handleSelect = (selectedItemID) => {
    onSelect(selectedItemID);
    setSearchTerm('');
  }

  const handleClickWarning = (event) => {
    event.stopPropagation();
    console.log('Last item clicked');
  };

  const searchPlaceholderText = `${possibleAnswers} possible answers...`;

  return (
    <div className='searchBar'>
      {/* <label htmlFor="search">Search:</label> */}
      <input
        size="10"
        type="text"
        id="search"
        placeholder={searchPlaceholderText}
        value={searchTerm}
        onKeyDown={handleKeyPress}
        onChange={(e) => setSearchTerm(e.target.value)}
        autoFocus
      />
      <div className='searchList'>
        {filteredData.length > 0 && (
          <ul>
            {filteredData.map((item) => (
              <li key={item.id} onClick={() => handleSelect(item.id)}>
                <img src={`https://static.atlasacademy.io/JP/Servants/Status/${item.id}/status_servant_1.png`} />
                <span style={{ paddingLeft: "10px" }}>{item.name}</span>
                {getOptionIds().includes(item.id) &&
                  <div onClick={handleClickWarning} className="dup-servent-icon">⚠️</div>}
              </li>

            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
